import React from 'react';
import { ArrowRight, Clock, AlertCircle, CheckCircle } from 'lucide-react';
export function ValueDemo() {
  return <section className="py-24 px-6 bg-slate-50" data-id="element-180">
      <div className="max-w-7xl mx-auto" data-id="element-181">
        <div className="text-center mb-16" data-id="element-182">
          <h2 className="text-4xl font-bold text-slate-900 mb-4" data-id="element-183">
            The impact is immediate
          </h2>
          <p className="text-xl text-slate-600" data-id="element-184">
            See how manufacturing teams transform their workflows
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 items-center" data-id="element-185">
          {/* Before */}
          <div className="bg-white rounded-xl p-8 border-2 border-red-200" data-id="element-186">
            <div className="text-sm font-semibold text-red-600 mb-4" data-id="element-187">
              BEFORE
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-188">
              Manual Process
            </h3>

            <div className="space-y-4" data-id="element-189">
              <div className="flex items-start gap-3" data-id="element-190">
                <Clock className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-191" />
                <div data-id="element-192">
                  <div className="font-semibold text-slate-900" data-id="element-193">
                    8 hours per week
                  </div>
                  <div className="text-sm text-slate-600" data-id="element-194">
                    Manual data entry time
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-195">
                <AlertCircle className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-196" />
                <div data-id="element-197">
                  <div className="font-semibold text-slate-900" data-id="element-198">
                    15% error rate
                  </div>
                  <div className="text-sm text-slate-600" data-id="element-199">
                    Data entry mistakes
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-200">
                <AlertCircle className="w-5 h-5 text-red-500 mt-0.5 flex-shrink-0" data-id="element-201" />
                <div data-id="element-202">
                  <div className="font-semibold text-slate-900" data-id="element-203">
                    Delayed updates
                  </div>
                  <div className="text-sm text-slate-600" data-id="element-204">
                    Hours or days behind
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Arrow */}
          <div className="flex justify-center" data-id="element-205">
            <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center shadow-thruline" data-id="element-206">
              <ArrowRight className="w-8 h-8 text-white" data-id="element-207" />
            </div>
          </div>

          {/* After */}
          <div className="bg-white rounded-xl p-8 border-2 border-emerald-200" data-id="element-208">
            <div className="text-sm font-semibold text-emerald-600 mb-4" data-id="element-209">
              AFTER
            </div>
            <h3 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-210">
              Automated Sync
            </h3>

            <div className="space-y-4" data-id="element-211">
              <div className="flex items-start gap-3" data-id="element-212">
                <CheckCircle className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-213" />
                <div data-id="element-214">
                  <div className="font-semibold text-slate-900" data-id="element-215">5 minutes</div>
                  <div className="text-sm text-slate-600" data-id="element-216">
                    One-time setup, then automatic
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-217">
                <CheckCircle className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-218" />
                <div data-id="element-219">
                  <div className="font-semibold text-slate-900" data-id="element-220">0% errors</div>
                  <div className="text-sm text-slate-600" data-id="element-221">
                    Perfect data accuracy
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-3" data-id="element-222">
                <CheckCircle className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" data-id="element-223" />
                <div data-id="element-224">
                  <div className="font-semibold text-slate-900" data-id="element-225">
                    Real-time updates
                  </div>
                  <div className="text-sm text-slate-600" data-id="element-226">
                    Instant synchronization
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom metric */}
        <div className="mt-12 text-center" data-id="element-227">
          <div className="inline-block bg-blue-600 text-white px-8 py-4 rounded-lg shadow-thruline" data-id="element-228">
            <div className="text-3xl font-bold mb-1" data-id="element-229">40+ hours saved</div>
            <div className="text-blue-100" data-id="element-230">per month, per engineer</div>
          </div>
        </div>
      </div>
    </section>;
}